
const CONFIG = {
  WEBHOOK_URL:      window.ZO_WEBHOOK_URL || "",
  WEBHOOK_AUTH:     window.ZO_WEBHOOK_AUTH || "",
  SHOPIFY_CHECKOUT: window.ZO_SHOPIFY_CHECKOUT || false,
  SHOPIFY_VARIANT_ID: window.ZO_SHOPIFY_VARIANT_ID || "",
  SHOPIFY_REDIRECT: window.ZO_SHOPIFY_REDIRECT || "/cart"
};

const DATA = {
  serien: [
    { id: "stone",  label: "Stone",  desc: "Steinoptik, zeitlos klassisch." },
    { id: "design", label: "Design", desc: "Edel, modern, markant." },
    { id: "wood",   label: "Wood",   desc: "Holzoptik, natürlich warm." }
  ],
  modelle: [
    // ====== STONE (9) ======
    { id: "wildstone",    serie: "stone",  name: "Wildstone",         kurz: "Rustikaler Charme einer wild gemauerten Wand.",                 preis_netto_m2: 89.10,  bild: "https://www.baj.be/sites/default/files/2024-05/Wildstone%201.jpg",                                                             highlight: true,  url: "https://www.baj.be/de/product/wildstone" },
    { id: "rustique",     serie: "stone",  name: "Rustique",          kurz: "Feine Steinschichten für ein erhabenes, natürliches Ergebnis.", preis_netto_m2: 80.10,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_Rustique_Grijs_RAL7010_2.JPG",                                 highlight: false, url: "https://www.baj.be/de/product/rustique" },
    { id: "sorento",      serie: "stone",  name: "Sorento",           kurz: "Vom Schiefer inspiriert, elegant und zeitlos.",                 preis_netto_m2: 91.80, bild: "https://www.baj.be/sites/default/files/2024-05/Sorento%201.jpg",                                                               highlight: true,  url: "https://www.baj.be/de/product/sorento" },
    { id: "firenze",      serie: "stone",  name: "Firenze",           kurz: "Schlicht, anmutig, mediterran – passt in jeden Garten.",        preis_netto_m2: 71.10,  bild: "https://cdn.shopify.com/s/files/1/1024/6432/3924/t/12/assets/znref-firenze.jpg?v=1786974142",                                 highlight: false, url: "https://www.baj.be/de/product/firenze" },
    { id: "linea",        serie: "stone",  name: "Linea",             kurz: "Kombination hoher und niedriger Steine für Abwechslung.",       preis_netto_m2: 75.60,  bild: "https://cdn.shopify.com/s/files/1/1024/6432/3924/t/12/assets/znref-linea.jpg?v=1786974142",                              highlight: false, url: "https://www.baj.be/de/product/linea" },
    { id: "romeins",      serie: "stone",  name: "Römischer Verband", kurz: "Mauerwerk-Optik aus früherer Zeit mit klassischer Anmutung.",  preis_netto_m2: 80.10,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_RomeinsVerband_GebrokenWit_RAL7032_2_1.JPG",                   highlight: false, url: "https://www.baj.be/de/product/roemischer-verband" },
    { id: "marseille",    serie: "stone",  name: "Marseille",         kurz: "Große Fugen, dynamisches Licht-und-Schatten-Spiel, südlich.",   preis_netto_m2: 82.80,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_Marseille_GebrokenWit_RAL7032.JPG",                            highlight: false, url: "https://www.baj.be/de/product/marseille" },
    { id: "nordic",       serie: "stone",  name: "Nordic",            kurz: "Rauhes, ruhiges und natürliches Aussehen.",                     preis_netto_m2: 73.80,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_Nordic_Grijs_RAL7010.JPG",                                     highlight: false, url: "https://www.baj.be/de/product/nordic" },
    { id: "maxi-stone",   serie: "stone",  name: "Maxi Stone",        kurz: "Größere Steine, beeindruckende Mauer-Wirkung.",                 preis_netto_m2: 78.30,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_MaxiStone_Antraciet_RAL7021.JPG",                              highlight: false, url: "https://www.baj.be/de/product/maxi-stone" },
    // ====== DESIGN (7) ======
    { id: "xline",        serie: "design", name: "Xline",             kurz: "Modernes X-förmiges Linienspiel, progressiv.",                  preis_netto_m2: 93.60, bild: "https://www.baj.be/sites/default/files/2023-02/DSC_3148.JPG",                                                                   highlight: true,  url: "https://www.baj.be/de/product/xline" },
    { id: "bamboo",       serie: "design", name: "Bamboo",            kurz: "Bambusstruktur mit lebendigen horizontalen Linien.",            preis_netto_m2: 86.40,  bild: "https://www.baj.be/sites/default/files/2025-09/BAJ-Beton%20Bamboo%20RAL%207030%20Grijs%20betonschutting.jpeg",                   highlight: false, url: "https://www.baj.be/de/product/bambus" },
    { id: "montega",      serie: "design", name: "Montega",           kurz: "Zeitgenössisches Design mit klarer Linienführung.",             preis_netto_m2: 89.10,  bild: "https://www.baj.be/sites/default/files/2025-02/Montega%202_0.jpg",                                                              highlight: false, url: "https://www.baj.be/de/product/montega" },
    { id: "rio",          serie: "design", name: "Rio",               kurz: "Elegant und robust, für klassische und moderne Gärten.",        preis_netto_m2: 84.60,  bild: "https://www.baj.be/sites/default/files/2024-11/Origiwall_Rio_RAL7010_BAJ-BETON%20%2810%29.jpg",                                  highlight: false, url: "https://www.baj.be/de/product/rio" },
    { id: "murano",       serie: "design", name: "Murano",            kurz: "Verspielte Modernität, markanter Blickfang.",                   preis_netto_m2: 87.30,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_Murano_GebrokenWit_RAL7032_5.JPG",                             highlight: false, url: "https://www.baj.be/de/product/murano" },
    { id: "luxo",         serie: "design", name: "Luxo",              kurz: "Minimalistisches Design für einen eleganten Garten.",           preis_netto_m2: 82.80,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_Luxo_Antraciet_RAL7021.JPG",                                   highlight: false, url: "https://www.baj.be/de/product/luxo" },
    { id: "vlak",         serie: "design", name: "Flache Platte",     kurz: "Zeitlose flache Platte, passt zu jedem Stil.",                  preis_netto_m2: 62.10,  bild: "https://www.baj.be/sites/default/files/2023-01/BAJ_Betonschutting_VlakkePlaat_Antraciet_RAL7021_1.jpg",                          highlight: false, url: "https://www.baj.be/de/product/flache-platte" },
    // ====== WOOD (4) ======
    { id: "woodox",       serie: "wood",   name: "Woodox",            kurz: "Flache Holzoptik, ruhig und natürlich.",                        preis_netto_m2: 78.30,  bild: "https://www.baj.be/sites/default/files/2023-01/BAJ_Betonschutting_Woodox_Grijs_RAL7010_10.jpg",                                  highlight: false, url: "https://www.baj.be/de/product/woodox" },
    { id: "solide",       serie: "wood",   name: "Solide",            kurz: "Versetzte Latten mit Tiefenwirkung und Schattenspiel.",         preis_netto_m2: 82.80,  bild: "https://www.baj.be/sites/default/files/2023-02/DSC_0012_0.JPG",                                                                 highlight: false, url: "https://www.baj.be/de/product/solide" },
    { id: "vlechtwerk",   serie: "wood",   name: "Flechtwerk",        kurz: "Wechselndes Geflecht-Muster, besondere Wirkung.",               preis_netto_m2: 80.10,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_Vlechtwerk_Antraciet_RAL7021_2_0.JPG",                         highlight: false, url: "https://www.baj.be/de/product/flechtwerk" },
    { id: "elegant",      serie: "wood",   name: "Elegant",           kurz: "Dekorative Tiefe durch Holzmotiv-Relief.",                      preis_netto_m2: 84.60,  bild: "https://www.baj.be/sites/default/files/2023-02/BAJ_Betonschutting_Elegant_GebrokenWit_RAL7032.JPG",                              highlight: false, url: "https://www.baj.be/de/product/elegant" }
  ],
  farben: {
    naturel: { label: "Naturel (unbehandelt)", hex: "#B8B5AE", kategorie: "naturel",  sortierung: 1,  aufschlag: 0.00 },
    ral7010: { label: "Grau RAL 7010",              hex: "#4C514A", kategorie: "standard", sortierung: 10, aufschlag: 0.05 },
    ral7039: { label: "Quarzgrau RAL 7039",         hex: "#6C6960", kategorie: "standard", sortierung: 11, aufschlag: 0.05 },
    ral7016: { label: "Anthrazitgrau RAL 7016",     hex: "#293133", kategorie: "standard", sortierung: 12, aufschlag: 0.05 },
    ral7021: { label: "Anthrazit RAL 7021",         hex: "#2F353B", kategorie: "standard", sortierung: 13, aufschlag: 0.05 },
    ral9005: { label: "Tiefschwarz RAL 9005",       hex: "#0E0E10", kategorie: "standard", sortierung: 14, aufschlag: 0.05 },
    ral7032: { label: "Gebrochenes Weiß RAL 7032",  hex: "#B9B9A8", kategorie: "standard", sortierung: 15, aufschlag: 0.05 },
    ral1014: { label: "Elfenbein RAL 1014",         hex: "#DFCEA1", kategorie: "standard", sortierung: 16, aufschlag: 0.05 },
    ral9010: { label: "Reinweiß RAL 9010",          hex: "#F1ECE1", kategorie: "standard", sortierung: 17, aufschlag: 0.05 },
    ral1020: { label: "Olivgelb RAL 1020",          hex: "#9A9464", kategorie: "standard", sortierung: 18, aufschlag: 0.05 },
    ral8002: { label: "Signalbraun RAL 8002",       hex: "#7B5141", kategorie: "standard", sortierung: 19, aufschlag: 0.05 },
    ral8016: { label: "Mahagonibraun RAL 8016",     hex: "#4A2F1F", kategorie: "standard", sortierung: 20, aufschlag: 0.05 },
    ral7006: { label: "Beigegrau RAL 7006",         hex: "#756F61", kategorie: "luxus",    sortierung: 30, aufschlag: 0.15 },
    ral7003: { label: "Moosgrau RAL 7003",          hex: "#7D7F7D", kategorie: "luxus",    sortierung: 31, aufschlag: 0.15 },
    ral6013: { label: "Schilfgrün RAL 6013",        hex: "#7D7547", kategorie: "luxus",    sortierung: 32, aufschlag: 0.15 },
    ral6003: { label: "Olivgrün RAL 6003",          hex: "#515744", kategorie: "luxus",    sortierung: 33, aufschlag: 0.15 },
    ral1019: { label: "Graubeige RAL 1019",         hex: "#9E8B71", kategorie: "luxus",    sortierung: 34, aufschlag: 0.15 },
    ral7030: { label: "Steingrau RAL 7030",         hex: "#8B8C7A", kategorie: "luxus",    sortierung: 35, aufschlag: 0.15 }
  },
  aufschlag_faktor: 1.10,
  plattenende: [
    { id: "gerade",       label: "Gerade Ausführung",  beschreibung: "Klassischer gerader Abschluss mit gerader Platte.",    preis_netto_pro_lfm: 12.60, icon: "https://www.baj.be/sites/default/files/2022-12/Rechte%20afwerking.svg" },
    { id: "bogen",        label: "Bogen-Abschluss",    beschreibung: "Geschwungene, abgerundete Bogenplatte als Abschluss.", preis_netto_pro_lfm: 16.20, icon: "https://www.baj.be/sites/default/files/2022-12/Ronde%20afwerking.svg" },
    { id: "abdeckleiste", label: "Mit Abdeckleiste",   beschreibung: "Saubere Abdeckleiste als Abschluss auf den Pfosten.",  preis_netto_pro_lfm: 10.80, icon: "https://www.baj.be/sites/default/files/2022-12/Afwerking%20met%20afdeklat.svg" }
  ],
  zaunformen: [
    { id: "gerade",     label: "Gerader Zaun",     seiten: 1, eckpfosten: 0, pfad: "M10 50 L190 50" },
    { id: "eck",        label: "Eckzaun (L-Form)", seiten: 2, eckpfosten: 1, pfad: "M10 50 L100 50 L100 140" },
    { id: "u_form",     label: "U-förmig",         seiten: 3, eckpfosten: 2, pfad: "M10 30 L10 140 L190 140 L190 30" },
    { id: "sonderform", label: "Andere Form",      seiten: 0, eckpfosten: 0, pfad: "M10 50 L60 100 L110 50 L160 120 L190 90", frei: true }
  ],
  hoehen_cm: [160, 200, 240, 280],
  zubehoer_optionen: [
    {
      id: "fundament_material",
      frage: "Beton bestellen?",
      erklaerung: "Folgende benötigte Materialien sind enthalten und werden für die Befestigung der Pfosten im Boden benötigt: Zement 32,5N / 25 kg und Stabilisierung (gebrochener Beton).",
      empfohlen: true,
      preis_netto_je_pfosten: 19.80,
      einheit: "pro_pfosten"
    },
    {
      id: "fugenmoertel",
      frage: "Fertigen Fugenmörtel bestellen?",
      erklaerung: "Dieser Mörtel ist in der gleichen Farbe wie Pfosten und Platten vorgefärbt und muss sowohl für die horizontalen als auch für die vertikalen Öffnungen verfugt werden.",
      empfohlen: true,
      preis_netto_pro_lfm: 7.65,
      einheit: "pro_lfm"
    },
    {
      id: "justierkeile",
      frage: "Justierkeile bestellen?",
      erklaerung: "Mit diesen Justierkeilen werden die Platten entlang der Zaunstirn im Pfosten verkeilt, um die Platte im Pfosten zu fixieren. Der Keil kann während des Verfugens entfernt werden oder im Zaun verbleiben.",
      empfohlen: true,
      preis_netto_pro_set: 17.91,
      einheit: "einmalig"
    },
    {
      id: "betonharz",
      frage: "Möchten Sie Betonharz/-lack bestellen?",
      erklaerung: "1) Um bei trockenem oder nassem Wetter die gleiche Farbe zu behalten. 2) Um eventuelle Farbunterschiede zu beseitigen. 3) Zur Bildung einer wasserabweisenden Schicht. Ca. 4–5 m² pro Liter.",
      empfohlen: true,
      preis_netto_pro_m2: 5.22,
      einheit: "pro_m2"
    },
    {
      id: "spruehgeraet",
      frage: "Sprühgerät bestellen?",
      erklaerung: "Damit können Sie Ihren Zaun besonders einfach behandeln. Elektrosprüher der Marke Wagner (W100).",
      empfohlen: true,
      preis_netto_einmalig: 116.10,
      einheit: "einmalig"
    }
  ],
  leistungen: {
    montage: {
      id: "montage_zaunonkel",
      label: "Montage durch Zaunonkel",
      pauschal_bis_lfm: 15,
      preis_pauschale_netto: 900.00,
      preis_netto_pro_weiteren_lfm: 54.00
    },
    lackieren: {
      id: "lackieren",
      label: "Lackieren (durch Zaunonkel)",
      preis_netto_pro_lfm: 18.00,
      benoetigt: "montage"
    }
  },
  preise_pfosten: {
    standard: { 160: 25.20, 200: 30.60, 240: 37.80, 280: 46.80 },
    eck:      { 160: 30.60, 200: 37.80, 240: 46.80, 280: 57.60 }
  },
  platte_laenge_m: 1.84,
  mwst: 0.19
};

/* ============================================================
   STATE
   ============================================================ */
const state = {
  _tab: "alle",
  form: null,
  hoehe_cm: 200,
  seiten: [],
  modellId: null,
  farbeId: null,
  plattenendeId: "gerade",
  zubehoer: {},
  leistungen: { montage: false, lackieren: false }
};

const STEPS = [
  { n: 1, label: "Modell" },
  { n: 2, label: "Form" },
  { n: 3, label: "Maße" },
  { n: 4, label: "Farbe" },
  { n: 5, label: "Zubehör" },
  { n: 6, label: "Montage" }
];

/* ============================================================
   UNLOCK LOGIC
   ============================================================ */
function seitenValid() {
  if (!state.form) return false;
  if (state.form === "sonderform") return state.seiten.length > 0 && state.seiten[0].laenge_m > 0;
  const f = DATA.zaunformen.find(x => x.id === state.form);
  return state.seiten.length === f.seiten && state.seiten.every(s => s.laenge_m > 0);
}

function stepUnlocked(n) {
  if (n === 1) return true;
  if (n === 2) return !!state.modellId;
  if (n === 3) return !!state.modellId && !!state.form;
  if (n === 4) return !!state.modellId && !!state.form && seitenValid();
  if (n === 5) return !!state.modellId && !!state.form && seitenValid() && !!state.farbeId;
  if (n === 6) return true; // always visible
  return false;
}

function stepDone(n) {
  if (n === 1) return !!state.modellId;
  if (n === 2) return !!state.form;
  if (n === 3) return seitenValid();
  if (n === 4) return !!state.farbeId;
  if (n === 5) {
    const allAnswered = DATA.zubehoer_optionen.every(z => state.zubehoer[z.id]);
    return !!state.plattenendeId && allAnswered;
  }
  if (n === 6) return false;
  return false;
}

/* ============================================================
   RENDER – Stepper (visual progress indicator)
   ============================================================ */
function renderStepper() {
  const el = document.getElementById("stepper");
  el.innerHTML = STEPS.map(s => {
    const isDone = stepDone(s.n);
    const isActive = !isDone && stepUnlocked(s.n);
    const cls = ["step", isActive && "active", isDone && "done"].filter(Boolean).join(" ");
    return `<div class="${cls}" data-scroll-to="${s.n}"><span class="num">${isDone ? "✓" : s.n}</span>${s.label}</div>`;
  }).join("");
  el.querySelectorAll("[data-scroll-to]").forEach(btn => {
    btn.addEventListener("click", () => {
      const card = document.getElementById("step-card-" + btn.dataset.scrollTo);
      if (card) card.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
}

/* ============================================================
   RENDER – All Steps
   ============================================================ */
function renderAllSteps() {
  const stepsConfig = [
    { n: 1, renderFn: renderStepModell },
    { n: 2, renderFn: renderStepForm },
    { n: 3, renderFn: renderStepMasse },
    { n: 4, renderFn: renderStepFarbe },
    { n: 5, renderFn: renderStepZubehoer },
    { n: 6, renderFn: renderStepMontage }
  ];

  document.getElementById("stepContent").innerHTML = stepsConfig.map(s => {
    const locked = !stepUnlocked(s.n);
    return `<div class="card step-panel${locked ? ' locked' : ''}" id="step-card-${s.n}">${s.renderFn()}</div>`;
  }).join("");

  bindAllEvents();
}

/* ============================================================
   RENDER – Step 1: Modell
   ============================================================ */
function renderStepModell() {
  const tabs = ["alle", ...DATA.serien.map(s => s.id)];
  const activeTab = state._tab || "alle";
  const filtered = activeTab === "alle" ? DATA.modelle : DATA.modelle.filter(m => m.serie === activeTab);

  return `
    <h2>1 · Modell wählen</h2>
    <p>20 Modelle in den Serien Stone, Design und Wood.</p>
    <div class="serie-tabs">
      ${tabs.map(t => {
        const lbl = t === "alle"
          ? "Alle (" + DATA.modelle.length + ")"
          : (DATA.serien.find(s => s.id === t)?.label || t) + " (" + DATA.modelle.filter(m => m.serie === t).length + ")";
        return `<button class="tab ${t === activeTab ? 'active' : ''}" data-tab="${t}">${lbl}</button>`;
      }).join("")}
    </div>
    <div class="modell-grid">
      ${filtered.map(m => {
        const preis = m.preis_netto_m2 * DATA.aufschlag_faktor;
        return `
          <div class="modell ${state.modellId === m.id ? 'selected' : ''}" data-modell="${m.id}" title="${m.kurz || ''}">
            <div class="thumb">
              ${m.highlight ? '<span class="badge">NEU</span>' : ''}
              ${m.bild
                ? `<img src="${m.bild}" alt="${m.name}" loading="lazy" decoding="async" onerror="this.style.display='none'"/>`
                : `<span class="thumb-fallback">${m.name}</span>`}
            </div>
            <div class="meta">
              <div class="name">${m.name}</div>
              <div style="font-size:.75rem;color:var(--ink-soft);margin:2px 0 4px;line-height:1.3;">${m.kurz || ''}</div>
              <div class="price">ab € ${preis.toFixed(2).replace('.', ',')} / m² netto · 18 Farben</div>
              <button class="btn-auswaehlen ${state.modellId === m.id ? 'active' : ''}" data-select="${m.id}">
                ${state.modellId === m.id ? '✓ Gewählt' : 'Auswählen'}
              </button>
            </div>
          </div>
        `;
      }).join("")}
    </div>
  `;
}

/* ============================================================
   RENDER – Step 2: Form
   ============================================================ */
function renderStepForm() {
  return `
    <h2>2 · Welche Form hat Ihr Zaun?</h2>
    <p>Wenn Ihre Form nicht dabei ist, wählen Sie „Andere Form" – wir beraten individuell.</p>
    <div class="choice-grid">
      ${DATA.zaunformen.map(f => `
        <button class="choice ${state.form === f.id ? 'selected' : ''}" data-form="${f.id}">
          <svg viewBox="0 0 200 170"><path d="${f.pfad}"/></svg>
          <div class="title">${f.label}</div>
          <div class="sub">${f.seiten ? f.seiten + ' Seite' + (f.seiten > 1 ? 'n' : '') : 'Individuell'}${f.eckpfosten ? ' · ' + f.eckpfosten + ' Eckpfosten' : ''}</div>
        </button>
      `).join("")}
    </div>
  `;
}

/* ============================================================
   RENDER – Step 3: Maße
   ============================================================ */
function renderStepMasse() {
  const form = DATA.zaunformen.find(f => f.id === state.form);
  if (!form) return "<h2>3 · Maße eingeben</h2><p>Bitte zuerst Zaunform wählen.</p>";

  if (state.seiten.length === 0) {
    const n = form.frei ? 1 : form.seiten;
    state.seiten = Array.from({length: n}, () => ({ laenge_m: "" }));
  }

  const seitenHtml = state.seiten.map((s, i) => `
    <div style="background:#f7f8fa;border-radius:8px;padding:16px;margin-bottom:10px;">
      <h3 style="margin-bottom:12px;">Seite ${i + 1}</h3>
      <div class="fields">
        <div class="field">
          <label>Länge in Metern</label>
          <input type="number" min="2" step="2" value="${s.laenge_m || ''}" data-seite="${i}" data-key="laenge_m" placeholder="z. B. 14"/>
          <div class="hint">Wird automatisch auf 2 m aufgerundet</div>
        </div>
      </div>
    </div>
  `).join("");

  return `
    <h2>3 · Maße eingeben</h2>
    <p>Wählen Sie eine Höhe für die gesamte Bestellung und geben Sie je Seite die Länge an. Für unterschiedliche Höhen bitte separate Bestellungen aufgeben.</p>
    <div style="background:#f7f8fa;border-radius:8px;padding:16px;margin-bottom:14px;max-width:280px;">
      <div class="field">
        <label>Höhe (gilt für alle Seiten)</label>
        <select data-global-hoehe>
          ${DATA.hoehen_cm.map(h => `<option value="${h}" ${state.hoehe_cm == h ? 'selected' : ''}>${h} cm</option>`).join("")}
        </select>
      </div>
    </div>
    ${seitenHtml}
    ${form.frei ? '<p><small>Bei Sonderformen übernimmt ein Mitarbeiter die exakte Berechnung.</small></p>' : ''}
  `;
}

/* ============================================================
   RENDER – Step 4: Farbe
   ============================================================ */
function renderStepFarbe() {
  const modell = DATA.modelle.find(m => m.id === state.modellId);

  const alleFarben = Object.entries(DATA.farben)
    .map(([id, f]) => ({ id, ...f }))
    .sort((a, b) => a.sortierung - b.sortierung);

  const gruppen = {
    naturel:  { titel: "Naturel – unbehandelter Beton (Basis, kein Aufschlag)",  farben: alleFarben.filter(f => f.kategorie === "naturel") },
    standard: { titel: "Standardfarben (11 RAL-Töne) · +5 % auf den Plattenpreis",  farben: alleFarben.filter(f => f.kategorie === "standard") },
    luxus:    { titel: "Luxusfarben (6 RAL-Töne) · +15 % auf den Plattenpreis",      farben: alleFarben.filter(f => f.kategorie === "luxus") }
  };

  const gruppeHtml = (g) => `
    <h3 style="margin-top:18px;font-size:.95rem;color:var(--ink-soft);font-weight:500;">${g.titel}</h3>
    <div class="farb-grid">
      ${g.farben.map(f => {
        const aufschlagText = f.aufschlag > 0 ? `+${(f.aufschlag * 100).toFixed(0)} %` : "Basis";
        return `
        <div class="farbe ${state.farbeId === f.id ? 'selected' : ''}" data-farbe="${f.id}">
          <div class="swatch" style="background:${f.hex}"></div>
          <div class="label">${f.label}</div>
          <div class="aufschlag">${aufschlagText}</div>
        </div>
        `;
      }).join("")}
    </div>
  `;

  return `
    <h2>4 · Farbe wählen</h2>
    <p>Alle Modelle in <b>18 Farben</b>: 1 Naturel + 11 Standardfarben + 6 Luxusfarben.${modell ? ' Gewähltes Modell: <b>' + modell.name + '</b>.' : ''}</p>
    ${gruppeHtml(gruppen.naturel)}
    ${gruppeHtml(gruppen.standard)}
    ${gruppeHtml(gruppen.luxus)}
  `;
}

/* ============================================================
   RENDER – Step 5: Plattenende & Zubehör
   ============================================================ */
function renderStepZubehoer() {
  const endeHtml = DATA.plattenende.map(p => {
    const preis = p.preis_netto_pro_lfm * DATA.aufschlag_faktor;
    return `
      <button class="choice choice-tall ${state.plattenendeId === p.id ? 'selected' : ''}" data-plattenende="${p.id}">
        <div class="ende-icon-wrap">
          <img src="${p.icon}" alt="${p.label}" class="ende-icon" loading="lazy"/>
        </div>
        <div class="title">${p.label}</div>
        <div class="sub">${p.beschreibung}</div>
        <div class="price-mini">+ € ${preis.toFixed(2).replace('.', ',')} / lfm netto</div>
      </button>
    `;
  }).join("");

  const zubehoerHtml = DATA.zubehoer_optionen.map(z => {
    const antwort = state.zubehoer[z.id];
    const preisHinweis = erklaerePreis(z);
    return `
      <div class="zubehoer-row">
        <div class="zubehoer-kopf">
          <div class="zubehoer-frage">${z.frage}</div>
          <div class="zubehoer-buttons">
            <button class="pill ${antwort === 'nein' ? 'pill-aktiv-nein' : ''}" data-zubehoer="${z.id}" data-antwort="nein">Nein</button>
            <button class="pill ${antwort === 'ja' ? 'pill-aktiv-ja' : ''}" data-zubehoer="${z.id}" data-antwort="ja">
              Ja${z.empfohlen ? ' — <span class="pill-sub">Empfohlen</span>' : ''}
            </button>
          </div>
        </div>
        <div class="zubehoer-erklaerung">${z.erklaerung}</div>
        <div class="zubehoer-preis">${preisHinweis}</div>
      </div>
    `;
  }).join("");

  return `
    <h2>5 · Plattenende & Zubehör</h2>
    <p>Wählen Sie den oberen Abschluss Ihres Zauns und beantworten Sie die Zubehör-Fragen.</p>
    <h3 style="margin-top:18px">Plattenende</h3>
    <div class="ende-grid">${endeHtml}</div>
    <h3 style="margin-top:24px">Zubehör</h3>
    <div class="zubehoer-liste">${zubehoerHtml}</div>
  `;
}

function erklaerePreis(z) {
  const f = DATA.aufschlag_faktor;
  if (z.einheit === "pro_pfosten") return `+ € ${(z.preis_netto_je_pfosten * f).toFixed(2).replace('.', ',')} netto pro Pfosten`;
  if (z.einheit === "pro_lfm")     return `+ € ${(z.preis_netto_pro_lfm * f).toFixed(2).replace('.', ',')} netto pro lfm`;
  if (z.einheit === "pro_m2")      return `+ € ${(z.preis_netto_pro_m2 * f).toFixed(2).replace('.', ',')} netto pro m²`;
  if (z.einheit === "einmalig" && z.preis_netto_pro_set)    return `+ € ${(z.preis_netto_pro_set * f).toFixed(2).replace('.', ',')} netto (Set)`;
  if (z.einheit === "einmalig" && z.preis_netto_einmalig)   return `+ € ${(z.preis_netto_einmalig * f).toFixed(2).replace('.', ',')} netto (einmalig)`;
  return "";
}

/* ============================================================
   RENDER – Step 6: Montage
   ============================================================ */
function renderStepMontage() {
  const calc = calculate();
  const mKonf = DATA.leistungen.montage;
  const lackPreis = DATA.leistungen.lackieren.preis_netto_pro_lfm;
  const montagePreis = berechneMontage(calc.laenge_m);
  const lackierenPreis = lackPreis * calc.laenge_m;

  const montageModus = !state.leistungen.montage ? "keine"
    : state.leistungen.lackieren ? "mit_lack" : "ohne_lack";

  return `
    <h2>6 · Montage</h2>
    <p>Wählen Sie, ob Ihr Zaun montiert und ggf. lackiert werden soll.</p>
    <div class="leistung-liste">
      <label class="versand-option ${montageModus === 'keine' ? 'aktiv' : ''}">
        <input type="radio" name="montage-modus" data-montage-modus="keine" ${montageModus === 'keine' ? 'checked' : ''}/>
        <div>
          <div class="leistung-label">Keine Montage – Selbstmontage</div>
          <div class="leistung-sub">Sie montieren den Zaun selbst. Montageanleitung liegt bei.</div>
        </div>
        <div class="leistung-preis">—</div>
      </label>
      <label class="versand-option ${montageModus === 'ohne_lack' ? 'aktiv' : ''}">
        <input type="radio" name="montage-modus" data-montage-modus="ohne_lack" ${montageModus === 'ohne_lack' ? 'checked' : ''}/>
        <div>
          <div class="leistung-label">Montage durch Zaunonkel – ohne Lackieren</div>
        </div>
        <div class="leistung-preis">${calc.laenge_m > 0 ? '€ ' + fmtEUR(montagePreis) : 'ab € ' + mKonf.preis_pauschale_netto.toFixed(0)}</div>
      </label>
      <label class="versand-option ${montageModus === 'mit_lack' ? 'aktiv' : ''}">
        <input type="radio" name="montage-modus" data-montage-modus="mit_lack" ${montageModus === 'mit_lack' ? 'checked' : ''}/>
        <div>
          <div class="leistung-label">Montage <b>mit</b> Lackieren</div>
          <div class="leistung-sub">Aufpreis € ${lackPreis.toFixed(0)} je lfm für die Lackierung.</div>
        </div>
        <div class="leistung-preis">${calc.laenge_m > 0 ? '€ ' + fmtEUR(montagePreis + lackierenPreis) : 'ab € ' + (mKonf.preis_pauschale_netto + 15 * lackPreis).toFixed(0)}</div>
      </label>
    </div>
  `;
}

/* ============================================================
   EVENTS
   ============================================================ */
function bindAllEvents() {
  // Tab-Filter
  document.querySelectorAll("[data-tab]").forEach(t => t.addEventListener("click", () => {
    state._tab = t.dataset.tab;
    render();
  }));

  // Modell-Auswahl nur über [data-select]-Button (delegiert)
  document.getElementById("stepContent").addEventListener("click", function(e) {
    const btn = e.target.closest("[data-select]");
    if (!btn) return;
    state.modellId = btn.dataset.select;
    render();
  });

  // Form
  document.querySelectorAll("[data-form]").forEach(b => b.addEventListener("click", () => {
    state.form = b.dataset.form;
    state.seiten = [];
    render();
  }));

  // Maße-Inputs: only update summary + lock states, no full re-render (preserves focus)
  document.querySelectorAll("[data-seite]").forEach(inp => {
    inp.addEventListener("input", (e) => {
      const i = parseInt(e.target.dataset.seite);
      const k = e.target.dataset.key;
      let v = k === "laenge_m" ? parseFloat(e.target.value) || 0 : parseInt(e.target.value);
      // Länge immer auf volle 2 m aufrunden
      if (k === "laenge_m" && v > 0) {
        v = Math.ceil(v / 2) * 2;
      }
      state.seiten[i][k] = v;
      updateLockStates();
      updateSummary();
      renderStepper();
    });
    // Aufrunden auch beim Verlassen des Feldes (blur) + Wert im Input anzeigen
    inp.addEventListener("blur", (e) => {
      if (e.target.dataset.key !== "laenge_m") return;
      const i = parseInt(e.target.dataset.seite);
      const raw = parseFloat(e.target.value) || 0;
      if (raw > 0) {
        const rounded = Math.ceil(raw / 2) * 2;
        e.target.value = rounded;
        state.seiten[i].laenge_m = rounded;
        updateLockStates();
        updateSummary();
        renderStepper();
      }
    });
  });

  // Globale Höhe (gilt für die gesamte Bestellung)
  const _ghSel = document.querySelector("[data-global-hoehe]");
  if (_ghSel) _ghSel.addEventListener("change", (e) => {
    state.hoehe_cm = parseInt(e.target.value) || 200;
    updateLockStates();
    updateSummary();
    renderStepper();
  });

  // Farbe
  document.querySelectorAll("[data-farbe]").forEach(f => f.addEventListener("click", () => {
    state.farbeId = f.dataset.farbe;
    render();
  }));

  // Plattenende
  document.querySelectorAll("[data-plattenende]").forEach(b => b.addEventListener("click", () => {
    state.plattenendeId = b.dataset.plattenende;
    render();
  }));

  // Zubehör
  document.querySelectorAll("[data-zubehoer]").forEach(b => b.addEventListener("click", () => {
    state.zubehoer[b.dataset.zubehoer] = b.dataset.antwort;
    render();
  }));

  // Montage-Modus
  document.querySelectorAll("[data-montage-modus]").forEach(el => el.addEventListener("change", (e) => {
    const modus = e.target.dataset.montageModus;
    state.leistungen.montage   = (modus !== "keine");
    state.leistungen.lackieren = (modus === "mit_lack");
    render();
  }));
}

/* Update lock states in-place without re-rendering content */
function updateLockStates() {
  [1, 2, 3, 4, 5, 6].forEach(n => {
    const card = document.getElementById("step-card-" + n);
    if (!card) return;
    if (stepUnlocked(n)) {
      card.classList.remove("locked");
    } else {
      card.classList.add("locked");
    }
  });
}

/* ============================================================
   BERECHNUNG
   ============================================================ */
function calculate() {
  const f = DATA.aufschlag_faktor;
  const laenge_m = state.seiten.reduce((s, x) => s + (x.laenge_m || 0), 0);
  const hoehe_cm = state.hoehe_cm || 200;
  const hoehe_m = hoehe_cm / 100;
  const flaeche_m2 = laenge_m * hoehe_m;

  const form = DATA.zaunformen.find(x => x.id === state.form);
  const pfosten_std = laenge_m > 0 ? Math.ceil(laenge_m / DATA.platte_laenge_m) + (form?.seiten || 1) : 0;
  const pfosten_eck = form?.eckpfosten || 0;
  const pfosten_gesamt = pfosten_std + pfosten_eck;

  const modell = DATA.modelle.find(m => m.id === state.modellId);
  const farbenEintrag = DATA.farben[state.farbeId];
  const farb_aufschlag = farbenEintrag ? (1 + farbenEintrag.aufschlag) : 1;
  const preis_platten = (modell?.preis_netto_m2 || 0) * flaeche_m2 * f * farb_aufschlag;

  const pfostenPreisStd = (DATA.preise_pfosten.standard[hoehe_cm] || 0) * f;
  const pfostenPreisEck = (DATA.preise_pfosten.eck[hoehe_cm] || 0) * f;
  const preis_pfosten = pfosten_std * pfostenPreisStd + pfosten_eck * pfostenPreisEck;

  const pEnde = DATA.plattenende.find(p => p.id === state.plattenendeId);
  const preis_plattenende = (pEnde?.preis_netto_pro_lfm || 0) * laenge_m * f;

  let preis_zubehoer = 0;
  const zubehoer_positionen = [];
  DATA.zubehoer_optionen.forEach(z => {
    if (state.zubehoer[z.id] !== "ja") return;
    let betrag = 0;
    if (z.einheit === "pro_pfosten") betrag = z.preis_netto_je_pfosten * pfosten_gesamt * f;
    else if (z.einheit === "pro_lfm")  betrag = z.preis_netto_pro_lfm * laenge_m * f;
    else if (z.einheit === "pro_m2")   betrag = z.preis_netto_pro_m2 * flaeche_m2 * f;
    else if (z.einheit === "einmalig") betrag = (z.preis_netto_pro_set || z.preis_netto_einmalig || 0) * f;
    preis_zubehoer += betrag;
    zubehoer_positionen.push({ id: z.id, label: z.frage, netto: betrag });
  });

  const preis_montage   = state.leistungen.montage ? berechneMontage(laenge_m) : 0;
  const preis_lackieren = (state.leistungen.montage && state.leistungen.lackieren)
    ? DATA.leistungen.lackieren.preis_netto_pro_lfm * laenge_m : 0;

  const netto_material = preis_platten + preis_pfosten + preis_plattenende + preis_zubehoer;
  const netto_warenkorb = preis_montage + preis_lackieren;
  const netto_gesamt = netto_material + netto_warenkorb;
  const brutto = netto_gesamt * (1 + DATA.mwst);

  return {
    laenge_m, hoehe_m, flaeche_m2,
    pfosten_std, pfosten_eck, pfosten_gesamt,
    preis_platten, preis_pfosten, preis_plattenende, preis_zubehoer,
    preis_montage, preis_lackieren,
    zubehoer_positionen,
    netto_material, netto_warenkorb,
    netto: netto_gesamt, brutto
  };
}

function berechneMontage(laenge_m) {
  const m = DATA.leistungen.montage;
  if (laenge_m <= 0) return 0;
  if (laenge_m <= m.pauschal_bis_lfm) return m.preis_pauschale_netto;
  return m.preis_pauschale_netto + (laenge_m - m.pauschal_bis_lfm) * m.preis_netto_pro_weiteren_lfm;
}

function fmtEUR(n) {
  return n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/* ============================================================
   SUMMARY SIDEBAR
   ============================================================ */
const VERSAND_BRUTTO = 300.00;
const VERSAND_NETTO  = Math.round(VERSAND_BRUTTO / (1 + DATA.mwst) * 100) / 100; // 252.10

function updateSummary() {
  const c = calculate();
  const modell = DATA.modelle.find(m => m.id === state.modellId);
  const farbe = DATA.farben[state.farbeId];
  const form = DATA.zaunformen.find(f => f.id === state.form);
  const plattenende = DATA.plattenende.find(p => p.id === state.plattenendeId);
  const fmt = n => n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  let html = "";

  /* ── 1. Modell-Vorschau ── */
  if (modell) {
    html += `<div class="sum-selection-card">
      <div class="sc-label">Modell</div>
      ${modell.bild ? `<img src="${modell.bild}" alt="${modell.name}" class="sum-preview-img"/>` : ""}
      <div class="sc-value">${modell.name}</div>
      <div class="sc-sub">${DATA.serien.find(s => s.id === modell.serie)?.label || modell.serie} · ab € ${(modell.preis_netto_m2 * DATA.aufschlag_faktor).toFixed(2).replace('.', ',')} / m² netto</div>
    </div>`;
  } else {
    html += `<div class="sum-selection-card"><div class="sc-label">Modell</div><div class="sum-empty-hint">Noch nicht gewählt</div></div>`;
  }

  /* ── 2. Farbe ── */
  if (farbe) {
    const aufschlagText = farbe.aufschlag > 0 ? ` · +${(farbe.aufschlag * 100).toFixed(0)} %` : " · Basis";
    html += `<div class="sum-selection-card">
      <div class="sc-label">Farbe</div>
      <div class="sum-farbe-row">
        <div class="sum-farbe-dot" style="background:${farbe.hex}"></div>
        <div>
          <div class="sc-value">${farbe.label}</div>
          <div class="sc-sub">${farbe.kategorie === "naturel" ? "Naturel" : farbe.kategorie === "standard" ? "Standardfarbe" : "Luxusfarbe"}${aufschlagText}</div>
        </div>
      </div>
    </div>`;
  } else {
    html += `<div class="sum-selection-card"><div class="sc-label">Farbe</div><div class="sum-empty-hint">Noch nicht gewählt</div></div>`;
  }

  /* ── 3. Form & Maße ── */
  if (form) {
    const massText = c.laenge_m > 0
      ? `${c.laenge_m.toFixed(1).replace('.', ',')} m lang · ${state.hoehe_cm || 200} cm hoch`
      : "Länge noch nicht eingegeben";
    html += `<div class="sum-selection-card">
      <div class="sc-label">Form & Maße</div>
      <div class="sc-value">${form.label}</div>
      <div class="sc-sub">${massText}</div>
      ${c.flaeche_m2 > 0 ? `<div class="sc-sub">Fläche: ${c.flaeche_m2.toFixed(1).replace('.', ',')} m² · ${c.pfosten_gesamt} Pfosten</div>` : ""}
    </div>`;
  } else {
    html += `<div class="sum-selection-card"><div class="sc-label">Form & Maße</div><div class="sum-empty-hint">Noch nicht gewählt</div></div>`;
  }

  /* ── 4. Plattenende ── */
  if (plattenende) {
    html += `<div class="sum-selection-card">
      <div class="sc-label">Plattenende</div>
      <div class="sc-value">${plattenende.label}</div>
    </div>`;
  }

  /* ── 5. Zubehör ── */
  const zubehoerJa = DATA.zubehoer_optionen.filter(z => state.zubehoer[z.id] === "ja");
  if (zubehoerJa.length) {
    html += `<div class="sum-selection-card">
      <div class="sc-label">Zubehör</div>
      ${zubehoerJa.map(z => `<div class="sc-sub" style="margin-top:3px;">✓ ${z.frage.replace(/ bestellen\?|Möchten Sie |\?/g,"").trim()}</div>`).join("")}
    </div>`;
  }

  /* ── 6. Montage ── */
  if (state.leistungen.montage) {
    html += `<div class="sum-selection-card">
      <div class="sc-label">Montage</div>
      <div class="sc-value">${state.leistungen.lackieren ? "Mit Lackieren" : "Ohne Lackieren"}</div>
      ${c.preis_montage > 0 ? `<div class="sc-sub">€ ${fmt(c.preis_montage + c.preis_lackieren)}</div>` : ""}
    </div>`;
  }

  /* ── Preisaufschlüsselung ── */
  if (c.netto_material > 0) {
    html += `<hr class="sum-divider"/>`;
    html += `<div class="sum-row"><span>Platten</span><span>€ ${fmt(c.preis_platten)}</span></div>`;
    html += `<div class="sum-row"><span>Pfosten</span><span>€ ${fmt(c.preis_pfosten)}</span></div>`;
    if (c.preis_plattenende > 0) html += `<div class="sum-row"><span>Plattenende</span><span>€ ${fmt(c.preis_plattenende)}</span></div>`;
    if (c.preis_zubehoer > 0)   html += `<div class="sum-row"><span>Zubehör</span><span>€ ${fmt(c.preis_zubehoer)}</span></div>`;
    if (c.preis_montage > 0)    html += `<div class="sum-row"><span>Montage</span><span>€ ${fmt(c.preis_montage)}</span></div>`;
    if (c.preis_lackieren > 0)  html += `<div class="sum-row"><span>Lackieren</span><span>€ ${fmt(c.preis_lackieren)}</span></div>`;
    html += `<div class="sum-row"><span>Versand (Spedition Festland)</span><span>€ ${fmt(VERSAND_BRUTTO)}</span></div>`;
    html += `<div class="sum-row sum-subtotal"><span>Netto gesamt</span><span><b>€ ${fmt(c.netto + VERSAND_NETTO)}</b></span></div>`;
  }

  document.getElementById("summaryBody").innerHTML = html;
  document.getElementById("sumTotal").textContent = "€ " + fmt(c.brutto + VERSAND_BRUTTO);
  const isReady = !!(state.modellId && state.farbeId && c.laenge_m > 0);
  const btn = document.getElementById("btnRequest");
  const hint = document.getElementById("btnRequestHint");
  if (btn) btn.style.opacity = isReady ? "1" : "0.5";
  if (hint) hint.style.display = isReady ? "none" : "block";
}

function row(lbl, val) {
  return `<div class="sum-row"><span>${lbl}</span><span><b>${val}</b></span></div>`;
}
function cartRow(lbl, val) {
  return `<div class="sum-row sum-cart"><span>${lbl}</span><span>${val}</span></div>`;
}

/* ============================================================
   LIFECYCLE
   ============================================================ */
function render() {
  renderStepper();
  renderAllSteps();
  updateSummary();
}

document.getElementById("btnRequest").addEventListener("click", () => {
  submitLead();
});

/* ============================================================
   SUBMIT
   ============================================================ */
async function submitLead() {
  const calc = calculate();
  const modell = DATA.modelle.find(m => m.id === state.modellId);
  const farbe  = DATA.farben[state.farbeId];
  const form   = DATA.zaunformen.find(f => f.id === state.form);
  const plattenende = DATA.plattenende.find(p => p.id === state.plattenendeId);

  const konfig = {
    quelle: "zaunonkel-beton-konfigurator",
    version: "v9",
    zeitstempel: new Date().toISOString(),
    konfiguration: {
      zaunform:    form?.label || null,
      zaunform_id: state.form,
      seiten:      state.seiten,
      modell:      modell ? { id: modell.id, name: modell.name, serie: modell.serie, url: modell.url, bild: modell.bild, preis_netto_m2: modell.preis_netto_m2 } : null,
      farbe:       farbe  ? { id: state.farbeId, label: farbe.label, hex: farbe.hex, kategorie: farbe.kategorie } : null,
      plattenende: plattenende ? { id: state.plattenendeId, label: plattenende.label } : null,
      zubehoer:    Object.fromEntries(DATA.zubehoer_optionen.map(z => [z.id, state.zubehoer[z.id] || "nein"]))
    },
    warenkorb_positionen: {
      montage:   state.leistungen.montage,
      lackieren: state.leistungen.lackieren
    },
    berechnung: {
      laenge_m:         round(calc.laenge_m, 2),
      hoehe_cm:         Math.round(calc.hoehe_m * 100),
      flaeche_m2:       round(calc.flaeche_m2, 2),
      pfosten_gesamt:   calc.pfosten_gesamt,
      netto_material:   round(calc.netto_material, 2),
      netto_warenkorb:  round(calc.netto_warenkorb, 2),
      netto_gesamt:     round(calc.netto, 2),
      brutto_eur:       round(calc.brutto, 2),
      mwst_prozent:     DATA.mwst * 100,
      aufschlag_faktor: DATA.aufschlag_faktor,
      einzelpositionen: {
        platten:     round(calc.preis_platten, 2),
        pfosten:     round(calc.preis_pfosten, 2),
        plattenende: round(calc.preis_plattenende, 2),
        zubehoer:    round(calc.preis_zubehoer, 2),
        montage:     round(calc.preis_montage, 2),
        lackieren:   round(calc.preis_lackieren, 2)
      }
    }
  };

  const reqBtn = document.getElementById("btnRequest");

  // Guard: check required selections
  const calc0 = calculate();
  if (!state.modellId || !state.farbeId || calc0.laenge_m <= 0) {
    showStatus("err", "Bitte Modell, Farbe und Länge auswählen.");
    return;
  }

  reqBtn.style.opacity = "0.5";
  reqBtn.style.pointerEvents = "none";

  const varId = CONFIG.SHOPIFY_VARIANT_ID;
  const checkout = CONFIG.SHOPIFY_CHECKOUT;
  showStatus("info", "Verbinde … (checkout=" + checkout + " variantId=" + varId + ")");

  if (CONFIG.WEBHOOK_URL) {
    fetch(CONFIG.WEBHOOK_URL, {
      method: "POST",
      headers: Object.assign({ "Content-Type": "application/json" },
                             CONFIG.WEBHOOK_AUTH ? { "X-ZO-Auth": CONFIG.WEBHOOK_AUTH } : {}),
      body: JSON.stringify(konfig)
    }).catch(err => console.warn("[ZO] Webhook-Fehler (ignoriert):", err));
  }

  if (checkout && varId) {
    showStatus("info", "Lege in Warenkorb … (Variant: " + varId + ")");
    try {
      const cartResult = await addToShopifyCart(konfig);
      showStatus("ok", "Erfolgreich! Weiterleitung zu " + CONFIG.SHOPIFY_REDIRECT + " …");
      setTimeout(() => { window.location.href = CONFIG.SHOPIFY_REDIRECT; }, 600);
      return;
    } catch (err) {
      console.error("[ZO] Shopify-Fehler:", err);
      if (err.message !== 'BLOCK_MISCHKORB') {
        showStatus("err",
          "Fehler: " + err.message + '<br><small>Bitte rufen Sie uns an: <a href="tel:+4949528299973">04952 8299973</a></small>');
      }
      reqBtn.style.opacity = "1";
      reqBtn.style.pointerEvents = "";
      return;
    }
  }

  // Prototyp-Modus (kein Variant-ID konfiguriert)
  showStatus("err", "Kein Variant-ID konfiguriert (checkout=" + checkout + " variantId='" + varId + "'). Bitte Admin prüfen.");
  reqBtn.style.opacity = "1";
  reqBtn.style.pointerEvents = "";
}

async function addToShopifyCart(konfig) {
  const fmt2 = n => n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const fmt1 = n => n.toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const k  = konfig.konfiguration;
  const b  = konfig.berechnung;
  const wp = konfig.warenkorb_positionen;
  const ep = b.einzelpositionen;

  // Short display names for Zubehör IDs
  const ZUBEHOER_KURZ = {
    fundament_material: "Beton",
    fugenmoertel:       "Fertigen Fugenmörtel",
    justierkeile:       "Justierkeile",
    betonharz:          "Betonharz/-lack",
    spruehgeraet:       "Sprühgerät"
  };

  const props = {};

  // Type marker (underscore = hidden in Shopify default cart/email display)
  props["_type"] = "betonzaun-konfig";

  // ── Modell ──
  if (k.modell) {
    const serieMap = { stone: "Stone", design: "Design", wood: "Wood" };
    const serie = serieMap[k.modell.serie] || k.modell.serie;
    props["Modell"]        = k.modell.name;
    props["Modell-Detail"] = serie + " · ab € " + fmt2(k.modell.preis_netto_m2) + " / m² netto";
  }

  // ── Farbe ──
  if (k.farbe) {
    const katLabel = k.farbe.kategorie === "naturel" ? "Naturel"
                   : k.farbe.kategorie === "standard" ? "Standardfarbe" : "Luxusfarbe";
    const aufschlag = k.farbe.kategorie === "standard" ? " · +5 %"
                    : k.farbe.kategorie === "luxus"    ? " · +15 %" : "";
    props["Farbe"]      = k.farbe.label;
    props["Farbe-Info"] = katLabel + aufschlag;
  }

  // ── Form & Maße ──
  if (k.zaunform && b.laenge_m > 0) {
    const hoehe_cm = b.hoehe_cm || 200;
    props["Form"]   = k.zaunform;
    props["Maße"]   = fmt1(b.laenge_m) + " m lang · " + hoehe_cm + " cm hoch";
    props["Fläche"] = fmt1(b.flaeche_m2) + " m² · " + b.pfosten_gesamt + " Pfosten";
    // Einzelne Seitenlängen (L-/U-Form) für die Bestellbestätigung
    if (state.seiten && state.seiten.length > 1) {
      props["Seitenlängen"] = state.seiten.map((s, i) => "Seite " + (i + 1) + ": " + fmt1(s.laenge_m || 0) + " m").join(" · ");
    }
  }

  // ── Plattenende ──
  if (k.plattenende) props["Plattenende"] = k.plattenende.label;

  // ── Zubehör (full names with checkmarks) ──
  const zubehoerGewahlt = Object.entries(k.zubehoer)
    .filter(([, v]) => v === "ja")
    .map(([id]) => "✓ " + (ZUBEHOER_KURZ[id] || id));
  if (zubehoerGewahlt.length) props["Zubehör"] = zubehoerGewahlt.join(" · ");

  // ── Montage ──
  if (wp.montage) props["Montage"] = wp.lackieren ? "Mit Lackieren" : "Ohne Lackieren";

  // ── Preisaufschlüsselung ──
  props["Preis-Platten"]  = "€ " + fmt2(ep.platten);
  props["Preis-Pfosten"]  = "€ " + fmt2(ep.pfosten);
  if (ep.plattenende > 0) props["Preis-Plattenende"] = "€ " + fmt2(ep.plattenende);
  if (ep.zubehoer > 0)    props["Preis-Zubehör"]     = "€ " + fmt2(ep.zubehoer);
  if (ep.montage > 0)     props["Preis-Montage"]      = "€ " + fmt2(ep.montage);
  if (ep.lackieren > 0)   props["Preis-Lackieren"]    = "€ " + fmt2(ep.lackieren);
  props["Versand (Spedition Festland)"]  = "€ " + fmt2(VERSAND_BRUTTO);
  props["Netto gesamt"]          = "€ " + fmt2(b.netto_gesamt + VERSAND_NETTO);
  props["Preis – Brutto gesamt"] = "€ " + fmt2(b.brutto_eur + VERSAND_BRUTTO);  // used for price line in cart
  props["Konfig-ID"]             = konfig.zeitstempel;

  const cartCheck = await fetch('/cart.js');
  const cartData = await cartCheck.json();
  const doppelstabImKorb = cartData.items.some(function(item) {
    return item.properties && item.properties['_konfigurator'] === 'doppelstab';
  });
  if (doppelstabImKorb) {
    showStatus('err', 'Betonzaun und Doppelstabzaun werden getrennt geliefert und müssen separat bestellt werden. Bitte schließen Sie zuerst Ihre aktuelle Bestellung ab.');
    throw new Error('BLOCK_MISCHKORB');
  }

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{
        id: parseInt(CONFIG.SHOPIFY_VARIANT_ID, 10),
        quantity: 1,
        properties: props
      }]
    })
  });
  if (!res.ok) {
    const errText = await res.text();
    throw new Error("Shopify /cart/add.js HTTP " + res.status + ": " + errText);
  }
  return res.json();
}

function round(n, d) { const f = Math.pow(10, d); return Math.round(n * f) / f; }

function showStatus(kind, htmlMsg) {
  try {
    let bar = document.getElementById("statusBar");
    if (!bar) {
      bar = document.createElement("div");
      bar.id = "statusBar";
      bar.className = "status-bar";
      // Insert before the summary card in the sidebar — always works
      const sidebar = document.querySelector(".sidebar") || document.getElementById("zo-baj-konfigurator-wrap");
      sidebar.insertBefore(bar, sidebar.firstChild);
    }
    bar.className = "status-bar status-" + kind;
    bar.innerHTML = htmlMsg;
  } catch(e) {
    console.error("[ZO] showStatus Fehler:", e, htmlMsg);
  }
}

function showSuccess(payload) {
  const c = document.getElementById("stepContent");
  c.innerHTML = `
    <div class="card step-panel success-panel">
      <div class="success-icon">✓</div>
      <h2>Konfiguration bereit für den Warenkorb</h2>
      <p>Im Live-Shop würde der Artikel jetzt in den Warenkorb gelegt und zur Kasse geleitet.</p>
      <div class="success-summary">
        <div class="sum-row"><span>Modell</span><span><b>${payload.konfiguration.modell?.name || "—"}</b></span></div>
        <div class="sum-row"><span>Farbe</span><span><b>${payload.konfiguration.farbe?.label || "—"}</b></span></div>
        <div class="sum-row"><span>Länge</span><span><b>${payload.berechnung.laenge_m} m</b></span></div>
        <div class="sum-row"><span>Fläche</span><span><b>${payload.berechnung.flaeche_m2} m²</b></span></div>
        ${payload.berechnung.brutto_eur > 0 ? `<div class="sum-row"><span>Gesamt brutto</span><span><b>€ ${payload.berechnung.brutto_eur.toLocaleString("de-DE", {minimumFractionDigits:2})}</b></span></div>` : ''}
      </div>
      <button class="btn btn-ghost" onclick="location.reload()">Neue Konfiguration starten</button>
    </div>
  `;
  document.getElementById("stepper").style.display = "none";
  const bar = document.getElementById("statusBar"); if (bar) bar.remove();
}

render();

/* ============================================================
   INLINE ZOOM + MODELL-AUSWAHL
   ============================================================ */
(function() {
  const sc = document.getElementById("stepContent");

  // Thumb-Klick: inline zoom toggle (capture → stopProp verhindert Bubble zum Karten-Handler)
  sc.addEventListener("click", function(e) {
    const thumb = e.target.closest(".thumb");
    if (!thumb) return;
    e.stopPropagation();
    const wasExpanded = thumb.classList.contains("expanded");
    document.querySelectorAll(".thumb.expanded").forEach(t => t.classList.remove("expanded"));
    if (!wasExpanded) thumb.classList.add("expanded");
  }, true);

  // Klick außerhalb: alle expanded schließen
  document.addEventListener("click", function(e) {
    if (!e.target.closest(".thumb")) {
      document.querySelectorAll(".thumb.expanded").forEach(t => t.classList.remove("expanded"));
    }
  });

  // Scroll: expanded schließen
  window.addEventListener("scroll", function() {
    document.querySelectorAll(".thumb.expanded").forEach(t => t.classList.remove("expanded"));
  }, { passive: true });
})();
